import React, { useEffect } from 'react';
import Welcome from './Welcome';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import EventPage from './Events/EventPage';
import NewsPage from './News/NewsPage';
import MenuPage from './Menu/MenuPage';
import './BasseCour.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <EventPage isActive={navigationContext.acitveAppKey === 'bacevent'} />
        <NewsPage isActive={navigationContext.acitveAppKey === 'bacnews'} />
        <MenuPage isActive={navigationContext.acitveAppKey === 'bacmenu'} />
        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
